const loadProsaCheckout = (callback,checkoutId) => {
  const existingScript = document.getElementById('prosaCheckout');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = process.env.REACT_APP_PROSA_PAYMENT_FORM_URL+checkoutId;
    script.id = 'prosaCheckout';
    document.body.appendChild(script);

    const scriptConf = document.createElement('script');
    scriptConf.id = "prosaConfig";
    scriptConf.text = " var wpwlOptions = {  style:'card',\n"+
                                            "locale: 'es',\n"+
                                            "maskCvv: true,\n"+
                                            "onReady: function(e){\n"+
                                                                  "$('.wpwl-label-cvv').text('CVV');\n"+
                                                                 "}\n"+
                                          "};";

    document.body.appendChild(scriptConf);

    script.onload = () => {
      if (callback){
        callback();
      } 
    };
  }

  if (existingScript && callback) {
    callback();
  }
};
export default (loadProsaCheckout);


// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/loadProsaCheckout.js